import React from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import ReactTable from "react-table";
import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SearchSelect from "components/common/SearchSelect";
import ReactTableFilterSelect from "components/custom/forms/react-table-filter-select";
import filterCaseInsensitive from "components/custom/forms/react-table-case-insensitive";
import { closeCustomModal, openCustomModal } from "components/custom/modals";

import {
    fetchSystemList,
    fetchSystemListItem,
    clearSystemList,
    clearSystemListItem
} from "api/menu/master-files/system-list/actions";

// import SystemItemModal from "components/menu/master-files/system-list/system-item-modal";
const SystemItemModal = React.lazy(() =>
    import("components/menu/master-files/system-list/system-item-modal"));

class SystemList extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            categories: [],
            category: null
        };

        this.modalOpen = this.modalOpen.bind(this);
    }

    componentDidMount () {
        this.props.fetchSystemList();
    }

    componentWillReceiveProps (nextProps) {
        if (nextProps.systems.length && !this.state.categories.length) {
            const categories = [];
            nextProps.systems.forEach((item) => {
                if (item.allowEdit) {
                    categories.push({
                        value: item.id,
                        label: item.description
                    });
                }
            });

            if (categories.length) {
                const category = categories[0];
                this.props.fetchSystemListItem(category.value);
                this.setState({
                    categories,
                    category
                });
            }
        }
    }

    componentWillUnmount () {
        this.props.clearSystemList();
        this.props.clearSystemListItem();
    }

    handleSelectCategory = (category) => {
        if (category !== this.state.category) {
            this.props.fetchSystemListItem(category.value);
            this.setState({
                category
            });
        }
    };

    modalOpen = (itemId = false) => {
        const modalTitle = itemId !== false ? "Update" : "Create";

        const modalObj = {
            id: `system-item-${itemId}`,
            header: `${modalTitle} List Item`,
            children: (
                <React.Suspense fallback={<div className="m-2 text-center font-weight-bold">Loading...</div>}>
                    <SystemItemModal
                        itemId={itemId}
                        categories={this.state.categories}
                        categoryCurrent={this.state.category}
                        onCancel={(needFetch) => {
                            this.props.closeCustomModal(modalObj);
                            if (needFetch) {
                                this.props.fetchSystemListItem(this.state.category.value);
                            }
                        }}
                    />
                </React.Suspense>
            ),
            handleClose: () => this.props.closeCustomModal(modalObj)
        };
        this.props.openCustomModal(modalObj);
    };

    render () {
        const {
            systemsItem,
            loading
        } = this.props;
        const {
            categories,
            category
        } = this.state;

        const classNameFlexCenter = "d-flex justify-content-center align-items-center";
        const columns = [
            {
                Header: "Code",
                accessor: "itemCode",
                id: "itemCode",
            },
            {
                Header: "Value",
                accessor: "value",
                id: "value",
            },
            {
                Header: "Active?",
                id: "inactive",
                accessor: original => (original.inactive ? "NO" : "YES"),
                Cell: ({ original }) => (original.inactive ? "NO" : "YES"),
                className: classNameFlexCenter,
                Filter: ({ filter, onChange }) => (
                    <ReactTableFilterSelect
                        currentValue={filter ? filter.value : ""}
                        onChange={value => onChange(value)}
                        style={{ width: "100%", height: "100%" }}
                        optionsObject={{
                            "": "Show All",
                            YES: "Active",
                            NO: "Inactive"
                        }}
                    />
                )
            },
            {
                Header: "Actions",
                id: "actions",
                className: classNameFlexCenter,
                Cell: ({ original }) => (
                    <Button size="sm" onClick={() => this.modalOpen(original.id)}>
                        <FontAwesomeIcon icon="pen" title="Update" />
                    </Button>
                ),
                filterable: false,
                width: 100
            }
        ];

        return (
            <div className="dashboard">
                <h3 className="mb-4">System List Maintenance</h3>

                <div className="mb-5">
                    <SearchSelect
                        options={categories}
                        isLoading={false}
                        isClearable={false}
                        isSearchable={true}
                        value={category}
                        onChange={this.handleSelectCategory}
                    />
                </div>

                <ReactTable
                    data={systemsItem}
                    headerClassName="table-header"
                    columns={columns}
                    defaultPageSize={20}
                    pageSizeOptions={[10, 20, 50, 100]}
                    resizable
                    className="-striped -highlight"
                    loading={loading}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    defaultSorted={[
                        {
                            id: "itemCode",
                            desc: false
                        }
                    ]}
                    defaultFiltered={[
                        {
                            id: "inactive",
                            value: "YES"
                        }
                    ]}
                    getNoDataProps = {() => ({
                        style: {
                            zIndex: 0
                        }
                    })}
                    style={{
                        height: "calc(100vh - 300px)",
                    }}
                />
                <div className="mt-4 mb-4 text-right">
                    <Button className="ml-2" variant="primary" onClick={() => this.modalOpen()}>
                        Add New System List item
                    </Button>
                </div>
            </div>
        );
    }
}

SystemList.propTypes = {
    fetchSystemList: PropTypes.func.isRequired,
    fetchSystemListItem: PropTypes.func.isRequired,
    clearSystemList: PropTypes.func.isRequired,
    clearSystemListItem: PropTypes.func.isRequired,
    systems: PropTypes.array.isRequired,
    loading: PropTypes.bool.isRequired,
};

const mapStateToProps = state => ({
    systems: state.systemLists.systems,
    systemsItem: state.systemLists.systemsItem,
    loading: state.systemLists.loading
});

const mapStateToDispatch = dispatch => ({
    fetchSystemList: bindActionCreators(fetchSystemList, dispatch),
    fetchSystemListItem: bindActionCreators(fetchSystemListItem, dispatch),
    clearSystemList: bindActionCreators(clearSystemList, dispatch),
    clearSystemListItem: bindActionCreators(clearSystemListItem, dispatch),

    openCustomModal: bindActionCreators(openCustomModal, dispatch),
    closeCustomModal: bindActionCreators(closeCustomModal, dispatch)
});

export default connect(
    mapStateToProps,
    mapStateToDispatch
)(SystemList);
